export const getKosmosReportLink = (kosmosCompanyId?: string, orgId?: string) : string => {
  const query = orgId ? `?organisationId=${orgId}` : '';
  if (kosmosCompanyId) {
    return `/reports/${kosmosCompanyId || ''}${query}`;
  }
  return '';
};

export const getSgReportLink = (kosmosCompanyId?: string, orgId?: string) : string => {
  const query = orgId ? `?organisationId=${orgId}` : '';
  if (kosmosCompanyId) {
    return `/combined-reports/${kosmosCompanyId || ''}${query}`;
  }
  return '';
};